import { useRef } from 'react';
import { openCameraCapture } from '../camera-capture/openCameraCapture';
import './PhotoActions.css';

export default function PhotoActions({ onFile, initialFacingMode = 'environment', onLoginRequired, onImport }) {
  const input = useRef(null);
  const act = action => {
    if (!localStorage.getItem('token') && onLoginRequired) onLoginRequired();
    else action();
  };
  return <div className={`photo-actions ${onImport ? 'photo-actions--compact' : ''}`} onClick={event => event.stopPropagation()}>
    <input ref={input} type="file" accept="image/*" hidden onChange={event => {
      const file = event.target.files?.[0];
      event.target.value = '';
      if (file) onFile(file);
    }} />
    <button type="button" onClick={() => act(() => input.current.click())}>
      <i aria-hidden="true" className="upload icon" />Upload Photo
    </button>
    <button type="button" onClick={() => act(() => openCameraCapture({ onCapture: onFile, initialFacingMode }))}>
      <i aria-hidden="true" className="camera icon" />Take Photo
    </button>
    {onImport && <button type="button" className="photo-import-menu" aria-label="Import options" title="Import options"
      onClick={() => act(onImport)}><i aria-hidden="true" className="ellipsis horizontal icon" /></button>}
  </div>;
}
